import { CircleUser } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../shared/components/dropdown-menu/DropdownMenu";
import { Button } from "../../../shared/components/button/Button";
import { useTranslation } from "react-i18next";
import useAuthentication from "../../../hooks/useAuthentication";
import { Link } from "react-router-dom";
import { SETTINGS } from "../../../shared/lib/routesResolver";

const ProfileDropdownMenu = () => {
  const { t } = useTranslation();
  const auth = useAuthentication();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon" className="rounded-full">
          <CircleUser className="h-5 w-5" />
          <span className="sr-only">Toggle user menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{auth.userLogged().fullname}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <Link className="w-full" to={SETTINGS}>
            {t("profile.dropdown.settings")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link
            className="w-full"
            to="https://forms.clickup.com/4771854/f/4hm0e-27952/ZBPVGZJRWGQR29JQ1T"
            target="_blank"
          >
            {t("profile.dropdown.support")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link
            className="w-full"
            to="https://forms.gle/84DTd31Jf8r9zr8u6"
            target="_blank"
          >
            {t("profile.dropdown.feedback")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <Link
            className="w-full"
            to="https://doc.clickup.com/4771854/d/h/4hm0e-27052/6dbefbdc10ba755"
            target="_blank"
          >
            {t("profile.dropdown.helpGuide")}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => auth.logout()}>
          {t("profile.dropdown.logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProfileDropdownMenu;
